export const EVENT_CODES_LOOKUP_TABLE = {
  api_limit: 'Rate Limit On API',
  cls: 'Code/Link Sent',
  coff: 'Connector Offline',
  con: 'Connector Online',
  cs: 'Code Sent',
  depnote: 'Deprecation Notice',
  du: 'Deleted User',
  f: 'usersActivitiesPage.events.failedLogin',
  fapi: 'Failed API Operation',
  fc: 'Failed by Connector',
  fce: 'Failed Change Email',
  fco: 'Failed by CORS',
  fcoa: 'Failed cross-origin authentication',
  fcp: 'Failed Change Password',
  fcph: 'Failed Post Change Password Hook',
  fcpn: 'Failed Change Phone Number',
  fcpr: 'Failed Change Password Request',
  fcpro: 'Failed Connector Provisioning',
  fcu: 'Failed Change Username',
  fd: 'Failed Delegation',
  fdeac: 'Failed Device Activation',
  fdeaz: 'Failed Device Authorization Request',
  fdecc: 'User Canceled Device Confirmation',
  fdu: 'Failed User Deletion',
  feacft: 'usersActivitiesPage.events.failedExchange',
  feccft: 'usersActivitiesPage.events.failedExchange',
  fede: 'usersActivitiesPage.events.failedExchange',
  fens: 'usersActivitiesPage.events.failedExchange',
  feoobft: 'usersActivitiesPage.events.failedExchange',
  feotpft: 'usersActivitiesPage.events.failedExchange',
  fepft: 'usersActivitiesPage.events.failedExchange',
  fepotpft: 'usersActivitiesPage.events.failedExchange',
  fercft: 'usersActivitiesPage.events.failedExchange',
  fertft: 'usersActivitiesPage.events.failedExchange',
  ferrt: 'usersActivitiesPage.events.failedExchange',
  flo: 'Failed Logout',
  fn: 'Failed Sending Notification',
  fp: 'Failed Login (Incorrect Password)',
  fs: 'Failed Signup',
  fsa: 'Failed Silent Auth',
  fu: 'Failed Login (Invalid Email/Username)',
  fui: 'Failed users import',
  fv: 'Failed Verification Email',
  fvr: 'Failed Verification Email Request',
  gd_auth_failed: 'OTP Auth failed',
  gd_auth_rejected: 'OTP Auth rejected',
  gd_auth_succeed: 'OTP Auth success',
  gd_enrollment_complete: 'Guardian enrollment complete',
  gd_module_switch: 'Module switch',
  gd_otp_rate_limit_exceed: 'Too many failures',
  gd_recovery_failed: 'Recovery failed',
  gd_recovery_rate_limit_exceed: 'Too many failures',
  gd_recovery_succeed: 'Recovery success',
  gd_send_pn: 'Push notification sent',
  gd_send_sms: 'SMS Sent',
  gd_send_sms_failure: 'SMS sent failures',
  gd_send_voice: 'Voice call made',
  gd_send_voice_failure: 'Voice call failure',
  gd_start_auth: 'Second factor started',
  gd_start_enroll: 'Enroll started',
  gd_tenant_update: 'Guardian tenant update',
  gd_unenroll: 'Unenroll device account',
  gd_update_device_account: 'Update device account',
  gd_user_delete: 'User delete',
  limit_delegation: 'Too Many Calls to /delegation',
  limit_mu: 'Blocked IP Address',
  limit_ui: 'Too Many Calls to /userinfo',
  limit_wc: 'Blocked Account',
  pwd_leak: 'Breached password',
  s: 'usersActivitiesPage.events.successLogin',
  sapi: 'Success API Operation',
  sce: 'Success Change Email',
  scoa: 'Success cross-origin authentication',
  scp: 'Success Change Password',
  scph: 'Success Post Change Password Hook',
  scpn: 'Success Change Phone Number',
  scpr: 'Success Change Password Request',
  scu: 'Success Change Username',
  sd: 'Success Delegation',
  sdu: 'Success User Deletion',
  seacft: 'usersActivitiesPage.events.successExchange',
  seccft: 'usersActivitiesPage.events.successExchange',
  sede: 'usersActivitiesPage.events.successExchange',
  sens: 'usersActivitiesPage.events.successExchange',
  seoobft: 'usersActivitiesPage.events.successExchange',
  seotpft: 'usersActivitiesPage.events.successExchange',
  sepft: 'usersActivitiesPage.events.successExchange',
  sercft: 'usersActivitiesPage.events.successExchange',
  sertft: 'usersActivitiesPage.events.successExchange',
  slo: 'usersActivitiesPage.events.successLogout',
  ss: 'usersActivitiesPage.events.successSignup',
  ssa: 'Success Silent Auth',
  sui: 'Success users import',
  sv: 'usersActivitiesPage.events.successVerificationEmail',
  svr: 'Success Verification Email Request',
  sys_os_update_end: 'Auth0 OS Update Ended',
  sys_os_update_start: 'Auth0 OS Update Started',
  sys_update_end: 'Auth0 Update Ended',
  sys_update_start: 'Auth0 Update Started',
  ublkdu: 'User login block released',
  w: 'Warnings During Login',
};
